import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PagesRoutingModule } from './pages-routing.module';

@NgModule({
    imports: [
        SharedModule,
        PagesRoutingModule,
        ReactiveFormsModule,
    ],
    declarations: [
    ],
    providers: []
})

export class PagesModule {}
